import { RouteRecordRaw } from "vue-router";

import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";
import { PATH } from "@/core/constants/path";
import featureConfigManager from "@/core/utils/featureConfig";

const isNewBookingDetailsPageEnabled = () =>
  featureConfigManager.isFeatureEnabled(
    "Booking Module",
    "new-booking-details",
  );

const routes: Array<RouteRecordRaw> = [
  {
    path: PATH.FLIGHTS_BOOKING_FORM,
    name: "bookingForm",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.PERMISSIONS,
    },
    component: () => import("../views/FlightBookingForm.vue"),
  },
  {
    path: PATH.FLIGHTS_BOOKING_DETAILS,
    name: "flightBookingDetails",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.PERMISSIONS,
    },
    component: () =>
      isNewBookingDetailsPageEnabled()
        ? import("../views/FlightBookingDetailsNew.vue")
        : import("../views/FlightBookingDetails.vue"),
  },
  {
    path: PATH.FLIGHTS_BOOKING_DETAILS_NEW,
    name: "flightBookingDetailsNew",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.PERMISSIONS,
    },
    component: () => import("../views/FlightBookingDetailsNew.vue"),
  },
  {
    path: PATH.FLIGHTS_BOOKING_DETAILS_OLD,
    name: "flightBookingDetailsOld",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.ROLES,
      permissions:
        ROLES_AND_PERMISSION_ON_ROUTES.FLIGHTS_BOOKING_FORM.PERMISSIONS,
    },
    component: () => import("../views/FlightBookingDetails.vue"),
  },
];

export default routes;
